<template>
	<div class="container-fluid">
		<service-toolbar heading="Service Apps"></service-toolbar>

		<addon-app-tab ui-location="Service Record"></addon-app-tab>
	</div>
</template>
<script type="text/javascript">
import JobMessages from "../JobMessages"
import ServiceToolbar from "./ServiceToolbar"
import ServiceMixins from "@/mixins/ServiceMixins.js"
import AddonAppTab from "@/components/AddonAppTab"
	
export default {
	name: "ServiceMessages",
	components: {
		ServiceToolbar,
		JobMessages,
		AddonAppTab
	},
	mixins: [ServiceMixins],
	created() {
		this.setServiceIfNotSet()
	}
}
</script>